<template>
    <div v-click-outside="closeDropdown" class="w-full relative">
        <label
            v-if="label"
            class="block mb-1 text-sm text-theme-muted font-semibold"
        >
            {{ label }}
        </label>
        <button
            ref="trigger"
            type="button"
            class="w-full flex items-center justify-between rounded-md border bg-theme-input text-theme-base px-3 py-2 text-sm text-left transition-colors focus:outline-none focus:ring-1"
            :class="[
                error
                    ? 'border-theme-danger focus:ring-theme-danger'
                    : 'border-theme-border focus:ring-theme-primary',
                disabled
                    ? 'opacity-80 cursor-not-allowed text-theme-disabled'
                    : ''
            ]"
            :disabled="disabled"
            @click="toggleOpen"
            @focus="$emit('focus')"
            @blur="$emit('blur')"
            @keydown.down.prevent="onArrowDown"
            @keydown.up.prevent="onArrowUp"
            @keydown.enter.prevent="onEnter"
            @keydown.esc="onEscape"
        >
            <span :class="!selectedLabel ? 'text-theme-muted' : ''">
                {{ selectedLabel || placeholder }}
            </span>
            <span class="ml-2 text-theme-muted">▾</span>
        </button>
        <div
            v-if="open"
            ref="panel"
            class="z-600 rounded-md border border-theme-border bg-theme-card shadow-lg"
            :style="dropdownStyle"
        >
            <div
                v-if="mode === 'search'"
                class="p-2 border-b border-theme-border"
            >
                <input
                    v-model="query"
                    type="text"
                    class="w-full rounded border border-theme-border bg-theme-input px-2 py-1 text-sm text-theme-base focus:outline-none"
                    placeholder="Buscar..."
                    @keydown.down.prevent="onArrowDown"
                    @keydown.up.prevent="onArrowUp"
                    @keydown.enter.prevent="onEnter"
                    @keydown.esc="onEscape"
                />
            </div>
            <div class="max-h-60 overflow-auto">
                <button
                    v-for="(option, index) in filteredOptions"
                    :key="option.value"
                    type="button"
                    class="w-full flex items-center gap-2 text-left px-3 py-2 text-sm text-theme-base hover:bg-theme-hover"
                    :class="{ 'bg-theme-hover': index === highlightedIndex }"
                    @click="selectOption(option)"
                >
                    <span
                        class="w-4 h-4 flex-shrink-0 rounded border flex items-center justify-center text-xs"
                        :class="
                            isSelected(option)
                                ? 'bg-theme-primary border-theme-primary text-theme-inverse'
                                : 'border-theme-border'
                        "
                    >
                        <span v-if="isSelected(option)">✓</span>
                    </span>
                    <span>{{ option.label }}</span>
                </button>
                <div
                    v-if="!filteredOptions.length"
                    class="px-3 py-2 text-sm text-theme-muted"
                >
                    Sin resultados
                </div>
            </div>
        </div>
        <p v-if="error" class="mt-1 text-xs text-theme-danger">
            {{ error }}
        </p>
    </div>
</template>

<script>
import customSelectDropdownMixin from "@/mixins/customSelectDropdownMixin";
import ClickOutside from "vue-click-outside";

export default {
    name: "CustomMultipleSelect",
    directives: {
        ClickOutside
    },
    mixins: [customSelectDropdownMixin],
    model: {
        prop: "value",
        event: "input"
    },
    props: {
        value: {
            default: () => [],
            type: Array,
            required: false
        }
    },
    emits: ["input", "change", "focus", "blur"],
    computed: {
        selectedLabel() {
            if (!this.value.length) return "";
            const labels = this.options
                .filter((option) => this.value.includes(option.value))
                .map((option) => option.label);
            return labels.length > 2
                ? `${labels.length} seleccionados`
                : labels.join(", ");
        }
    },
    methods: {
        isSelected(option) {
            return this.value.includes(option.value);
        },
        selectOption(option) {
            const index = this.value.indexOf(option.value);
            const newValue = [...this.value];
            if (index > -1) {
                newValue.splice(index, 1);
            } else {
                newValue.push(option.value);
            }
            this.$emit("input", newValue);
            this.$emit("change", newValue);
        }
    }
};
</script>
